import { render } from "./HjpDataTable.vue?vue&type=template&id=4e205626&ts=true"
import script from "@/composables/components/table/HjpDataTableComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/components/table/HjpDataTableComposable.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__